export default __webpack_public_path__ + "static/media/ed2mit2021tuto_A01.02-cloud-arch-services-v01.da5b3a93.pdf";